import { IconSVGProps } from "./types";

const TokenizeByLinkIcon = ({ height = 20, width = 20, className }: IconSVGProps) => (
    <svg
        className={className}
        width={width}
        height={height}
        viewBox={`0 0 ${20} ${20}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            opacity="0.4"
            d="M0 8.125C0 11.2305 4.47656 13.75 10 13.75C15.5234 13.75 20 11.2305 20 8.125C20 5.01953 15.5234 2.5 10 2.5C4.47656 2.5 0 5.01953 0 8.125Z"
            fill="#002649"
        />
        <path
            d="M1.875 12.9297C1.16016 12.4805 0.515625 11.9453 0 11.332V12.5C0 13.5898 0.695312 14.5938 1.875 15.4141V12.9297ZM3.125 13.6055V16.1328C4.18359 16.6328 5.46094 17.0195 6.875 17.2539V14.7422C5.50391 14.5078 4.23438 14.1211 3.125 13.6094V13.6055ZM10 17.5C9.35938 17.5 8.73047 17.4687 8.125 17.4141V14.9102C8.73828 14.9727 9.36328 15.0039 10 15.0039C10.6367 15.0039 11.2617 14.9727 11.875 14.9102V17.4141C11.2695 17.4727 10.6406 17.5 10 17.5ZM13.125 14.7383V17.25C14.5391 17.0156 15.8164 16.6289 16.875 16.1289V13.6016C15.7656 14.1172 14.4961 14.5 13.125 14.7344V14.7383ZM20 12.5C20 13.5898 19.3047 14.5938 18.125 15.4141V12.9258C18.8398 12.4766 19.4844 11.9414 20 11.3281V12.4961V12.5Z"
            fill="#002649"
        />
    </svg>
);

export default TokenizeByLinkIcon;
